import script from "./MarkdownWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownWorkspace.vue?vue&type=script&setup=true&lang=js"

import "./MarkdownWorkspace.vue?vue&type=style&index=0&id=4929b70d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4929b70d"]])

export default __exports__